import { APP_ROUTES } from '@zorro/common-utils';
import { StrictExtract } from '@zorro/types';
import { $enum } from 'ts-enum-util';

type BulkApplicationRoutes = StrictExtract<
  typeof APP_ROUTES,
  | 'OPS_BULK_CARRIER_APPLICATION_ENROLLMENT_INFO'
  | 'OPS_BULK_CARRIER_APPLICATION_PAYMENT_METHOD'
  | 'OPS_BULK_CARRIER_APPLICATION_COMPLETE'
  | 'OPS_ENROLLMENT_MANAGEMENT'
>;

export type BulkApplicationHandleStepSubmit = () => Promise<{
  navigate: boolean;
}>;

export enum BulkApplicationStepType {
  ENROLLMENT_INFO = 'ENROLLMENT_INFO',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  COMPLETE = 'COMPLETE',
}

export const getBulkApplicationStepConfig = (step: BulkApplicationStepType) =>
  $enum.mapValue(step).with<{
    nextRoute: BulkApplicationRoutes;
    prevRoute: BulkApplicationRoutes;
    stepIndex: number;
    label: string;
  }>({
    [BulkApplicationStepType.ENROLLMENT_INFO]: {
      nextRoute: 'OPS_BULK_CARRIER_APPLICATION_PAYMENT_METHOD',
      prevRoute: 'OPS_ENROLLMENT_MANAGEMENT',
      label: 'Enrollment info',
      stepIndex: 0,
    },
    [BulkApplicationStepType.PAYMENT_METHOD]: {
      nextRoute: 'OPS_BULK_CARRIER_APPLICATION_COMPLETE',
      prevRoute: 'OPS_BULK_CARRIER_APPLICATION_ENROLLMENT_INFO',
      label: 'Payment method',
      stepIndex: 1,
    },
    [BulkApplicationStepType.COMPLETE]: {
      nextRoute: 'OPS_ENROLLMENT_MANAGEMENT',
      prevRoute: 'OPS_BULK_CARRIER_APPLICATION_PAYMENT_METHOD',
      label: 'Complete application',
      stepIndex: 2,
    },
  });
